/**
 * @param names
 * @returns Space separated string with all classes to set on className property on HtmlElement
 */
export function joinNames(
    ...names: (string | false | undefined)[]
): string | undefined {
    return names.filter((s) => !!s).join(" ") || undefined;
}
